import { Row, Col } from "react-bootstrap";

export default function PageHeader({
  title,
  buttonText,
  onAdd,
}) {
  return (
    <div className="page-header">

      <Row>
        <Col md={10}>
          <h2>{title}</h2>
        </Col>
        {
          buttonText && (
            <>

              <Col md={2} className="float-end">
                <button
                  className="primary-btn btn btn-outline-light"
                  onClick={onAdd}
                >
                  + {buttonText}
                </button>
              </Col>
            </>
          )
        }

      </Row>




    </div>
  );
}